import { getFirestore, collection, query, getDocs } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from 'firebase/storage';

/**
 * Get photo gallery
 * @returns Array of all photos
 */
const getPhotoGallery = async () => {
    let localArrayOfPhotos = []
    const db = getFirestore();
    const q = query(collection(db, "photos"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((photo) => {
        let localPhoto = photo.data()
        localPhoto.__key = photo.id
        localArrayOfPhotos.push(localPhoto);

    });

    const storage = getStorage();

    /* Put image */
    for (let index = 0; index < localArrayOfPhotos.length; index++) {
        const photo = localArrayOfPhotos[index];
        let imageRef = ref(storage, 'photos/' + photo.__key);
        let url = await getDownloadURL(imageRef);
        localArrayOfPhotos[index]['img'] = url;
    }

    return localArrayOfPhotos;
}

export {
    getPhotoGallery,
}